import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, Input, EventEmitter, ChangeDetectorRef, Component, Output, ViewChild, Injectable, KeyValueDiffers, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@mobilize/angularclient';
import { WMConstants, WebMapService, AngularCommand, WebMapModule, SendMessage } from '@mobilize/angularclient';
import { WMLogger } from '@mobilize/logging';
import { ExceptionHandlerClass, ErrorCodes, Constants, registerModel } from '@mobilize/webmap-core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from 'ngx-toastr';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { By, BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'reflect-metadata';

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ContainerDirective {
    /* c8 ignore start */
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
ContainerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
ContainerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: ContainerDirective, selector: "[wm-content]", inputs: { hostComponent: "hostComponent" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[wm-content]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { hostComponent: [{
                type: Input
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class TypeResolver {
    static registrateType(key, type) {
        TypeResolver.typesDictionary[key] = type;
    }
    static getType(key) {
        return TypeResolver.typesDictionary[key];
    }
}
TypeResolver.typesDictionary = {};

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class EventData {
    /**
     * Creates a new EventData object that keeps
     * information about the executed event and
     * the sender component
     * @param event The original javascript event object
     * @param Id The sender component id
     * @param mapperId The sender component mapperId
     */
    constructor(event, Id, mapperId) {
        this.event = event;
        this.Id = Id;
        this.mapperId = mapperId;
    }
}

let FormsContainerComponent = class FormsContainerComponent {
    constructor(changeDetector, webmapService) {
        this.changeDetector = changeDetector;
        this.webmapService = webmapService;
        this.Loaded = new EventEmitter();
        this.openedComponents = {};
        this.events = [];
    }
    /* c8 ignore start */
    ngOnInit() {
        this.events.push(this.webmapService.core.getEvent().subscribe('navigateToView', (url) => {
            this.navigateToForm(url);
        }));
        this.events.push(this.webmapService.core.getEvent().subscribe('disposeView', (url) => {
            this.disposeComponent(url);
        }));
        this.events.push(this.webmapService.core.getEvent().subscribe('detectChanges', (url) => {
            this.detectChanges();
        }));
        this.events.push(this.webmapService.core.getEvent().subscribe('bringToFront', (url) => {
            this.bringToFront(url);
        }));
        this.events.push(this.webmapService.core.getEvent().subscribe('setTopView', (url) => {
            this.setTopView(url);
        }));
        this.events.push(this.webmapService.core
            .getEvent()
            .subscribe('navigateSystemDialog', (data) => {
            this.navigateToSystemDialog(data);
        }));
        this.events.push(this.webmapService.core.getEvent().subscribe('MessageBox', (data) => {
            this.showMessageBox(data);
        }));
        this.events.push(this.webmapService.core.getEvent().subscribe('FileExplorer', (data) => {
            this.showFileExplorer(data);
        }));
    }
    /* c8 ignore stop */
    ngAfterViewInit() {
        // Emit the loaded event to notify when FormsContainer component is fully loaded
        this.Loaded.emit(new EventData({}, this.parentId));
    }
    /**
     * Get the id of an input model
     * @param model the current model object
     */
    getId(model) {
        return this.webmapService.config.webMapVersion === WMConstants.version4
            ? model.UniqueID
            : model.id;
    }
    /**
     * Load a new component inside the formsContainerComponent
     * @param url the url object of the component.
     */
    /* c8 ignore start */
    navigateToForm(id) {
        this.webmapService.getModel(id).then((model) => {
            if (!this.shouldOpen(model)) {
                return;
            }
            const type = model.mapperId !== undefined ? model.mapperId : model.Name;
            const componentType = TypeResolver.getType(type);
            if (!componentType) {
                WMLogger.instance()
                    .error(`There is not a type registered with the name ${type} in the TypeResolver.
          Please check that the name is well written or the dataTransfer is the same in the backend`);
                return;
            }
            if (this.webmapService.config.wmSourceVersion ===
                WMConstants.sourceVersionWin &&
                model.ParentInternal) {
                return;
            }
            this.loadComponent(componentType, model);
            this.detectChanges();
            if (model.closeByTime) {
                setTimeout(() => {
                    this.disposeComponent(id);
                    this.webmapService.core.viewManager.models.deleteCascade(id);
                }, model.closeByTime);
            }
        });
    }
    /* c8 ignore stop */
    /**
     * Validates if the window should be open in the respective parent window.
     * @param mod The window model.
     */
    shouldOpen(mod) {
        if (mod) {
            const parent = this.parent(mod);
            return ((parent && this.getId(parent) === this.parentId) ||
                (!parent && this.parentId === undefined));
        }
        return false;
    }
    /**
     * Parents forms container component, determines if is Winforms or PB
     * @param mod Model
     * @returns parent determines if is Winforms(Parent) or PB(ParentWindow)
     */
    parent(mod) {
        if (this.webmapService.config) {
            switch (this.webmapService.config.wmSourceVersion) {
                case WMConstants.sourceVersionPB:
                    return mod.ParentWindow;
                case WMConstants.sourceVersionWebForms:
                    return mod.Master;
                default:
                    return mod.MdiParentInternal || mod.ParentInternal;
            }
        }
        return mod.MdiParentInternal || mod.ParentInternal;
    }
    /**
     * Load the messageBox component inside the formsContainerComponent
     * @param params params to show message box.
     */
    /* c8 ignore next 3 */
    showMessageBox(params) {
        this.showDialog(params, 'msgBx');
    }
    /**
     * Load the messageBox component inside the formsContainerComponent
     * @param params params to show file explorer.
     */
    /* c8 ignore next 3 */
    showFileExplorer(params) {
        this.showDialog(params, 'FlEpr');
    }
    /**
     * Opens a dialog according with type specified.
     * @param params params to open dialog.
     * @param type type of dialog to be open.
     */
    /* c8 ignore next 6 */
    showDialog(params, type) {
        const componentType = TypeResolver.getType(type);
        if (componentType && !this.parentId) {
            this.loadComponent(componentType, params);
        }
    }
    /**
     * Handler for the navigateSystemDialog event
     * display the selected system dialog.
     * @param data The current system dialog information.
     */
    /* c8 ignore next 7 */
    navigateToSystemDialog(data) {
        const componentToLoad = TypeResolver.getType(data.dialog);
        if (componentToLoad && !this.parentId) {
            const componentRef = this.loadComponent(componentToLoad, data.dialog);
            componentRef.instance.model = data.model.arguments;
        }
    }
    /**
     * Creates a new component instance inside the formscontainer component
     * @param componentToLoad The new component to load
     * @param name The name of the component.
     */
    /* c8 ignore start */
    loadComponent(componentToLoad, model) {
        const componentRef = this.componentContainer.viewContainerRef.createComponent(componentToLoad);
        componentRef.instance.model = model;
        if (componentRef.instance.afterLoadComponent) {
            componentRef.instance.afterLoadComponent();
        }
        const id = this.getId(model);
        this.openedComponents[id] = componentRef;
        if (this.webmapService?.core?.removePendingView) {
            this.webmapService.core.removePendingView(id);
        }
        return componentRef;
    }
    /* c8 ignore stop */
    /**
     *  Removes a component inside the formsContainerComponent
     * @param url the url object of the component.
     */
    /* c8 ignore start */
    disposeComponent(id) {
        if (id && this.openedComponents[id] && this.openedComponents[id].hostView) {
            const viewContainerRef = this.componentContainer.viewContainerRef;
            const vcrIndex = viewContainerRef.indexOf(this.openedComponents[id].hostView);
            try {
                viewContainerRef.remove(vcrIndex);
            }
            catch (e) {
                // Avoid triggering synchronization error while deleting the component.
                WMLogger.instance().debug(e);
            }
            delete this.openedComponents[id];
        }
        else {
            WMLogger.instance().debug(`The view ${id} to be removed was not found:
        ${this.openedComponents[id]
                ? 'HostView property undefined.'
                : ' The view is not present in the openedComponents collection.'}`);
        }
    }
    /* c8 ignore stop */
    /**
     * Modifies the SetTopView value to set the
     * corresponding for as the top element
     * @param id  The current view id
     */
    setTopView(id) {
        /* c8 ignore else */
        if (id && this.openedComponents[id]) {
            this.openedComponents[id].instance.model.SetTopView = true;
        }
    }
    /**
     * Performs a change detection manually in
     * the components tree.
     */
    detectChanges() {
        /* c8 ignore else */
        if (!this.changeDetector.destroyed) {
            this.changeDetector.detectChanges();
        }
    }
    /**
     *  Brings te current form focused unless there
     *  is a dialog displayed.
     * @param url the url object of the component.
     */
    /* c8 ignore next 5 */
    bringToFront(url) {
        if (url.length === 2 && url[1]) {
            this.openedComponents[url[1]].bringToFront();
        }
    }
    /**
     * Executes on component destroy to unsubscribe the events
     */
    ngOnDestroy() {
        this.events.forEach((evnt) => {
            this.webmapService.core.getEvent().unSubscribe(evnt);
        });
    }
};
FormsContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormsContainerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.Component });
FormsContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FormsContainerComponent, selector: "wm-formscontainer", inputs: { parentId: "parentId" }, outputs: { Loaded: "Loaded" }, viewQueries: [{ propertyName: "componentContainer", first: true, predicate: ContainerDirective, descendants: true, static: true }], ngImport: i0, template: "<ng-template wm-content></ng-template>", styles: [""], dependencies: [{ kind: "directive", type: ContainerDirective, selector: "[wm-content]", inputs: ["hostComponent"] }] });
FormsContainerComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.BaseComponents),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        WebMapService])
], FormsContainerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormsContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-formscontainer', template: "<ng-template wm-content></ng-template>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WebMapService }]; }, propDecorators: { Loaded: [{
                type: Output
            }], componentContainer: [{
                type: ViewChild,
                args: [ContainerDirective, { static: true }]
            }], parentId: [{
                type: Input
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class LoadingStateService {
    /**
     * Creates an instance of LoadingStateService.
     *
     * @memberof LoadingStateService
     */
    constructor() {
        /**
         * Internal property to save the hidden state of the loading component.
         * Default value is true in case there is no loading component in the app.
         * When the loading component is initialized, it should set the state.
         *
         * @private
         * @memberof LoadingStateService
         */
        this.isLoadingHiddenInternal = true;
    }
    /**
     * Gets/sets the isLoadingHidden property.
     *
     * @memberof LoadingStateService
     */
    set isLoadingHidden(value) {
        this.isLoadingHiddenInternal = value;
    }
    get isLoadingHidden() {
        return this.isLoadingHiddenInternal;
    }
}
LoadingStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LoadingStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LoadingStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LoadingStateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LoadingStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

let LoadingComponent = class LoadingComponent {
    /* c8 ignore start */
    constructor(service, loadingStateService) {
        this.service = service;
        this.loadingStateService = loadingStateService;
        /* c8 ignore stop */
        /**
         * Miliseconds to wait before showing the loading modal
         */
        this.timing = 800;
        /**
         * Events to unsubscribe on destroy.
         *
         * @private
         * @memberof LoadingComponent
         */
        this.events = [];
        /**
         * Internal property to save the hidden status.
         *
         * @private
         * @memberof LoadingComponent
         */
        this.hideInternal = false;
        this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
        this.manualTrigger = false;
        /**
         * Pending response requests of loading component
         * An object that holds a pointer of every setTimeout
         * function that should be activated by any performed request that
         * want to start the busy-loader component
         */
        this.pendingResponseRequests = {};
        /**
         * Still waiting requests of loading component
         * Holds the request wich the triggerd have been fired but the
         * loading component was already active should be verified every time
         * a request receive a response and want to hide the loading component.
         * Also if a request receives its response and it wasn't processed should be removed from
         * this object.
         */
        this.stillWaitingRequests = {};
        this.hide = false;
        this.serverInstance = this.service.core.inject.resolve(Constants.Server);
        this.events.push(this.service.core.getEvent().subscribe('TriggerLoading', (show) => {
            this.manualTrigger = show;
            this.hide = !show;
        }));
        this.events.push(this.service.core.getEvent().subscribe('DisplayLoading', (args) => {
            if (!this.manualTrigger) {
                this.handleDisplayLoadingEvent(args);
            }
        }));
    }
    /**
     * Gets/sets the hiddent property.
     *
     * @memberof LoadingComponent
     */
    set hide(value) {
        this.hideInternal = value;
        this.loadingStateService.isLoadingHidden = value;
    }
    get hide() {
        return this.hideInternal;
    }
    /**
     * Handles display loading event
     * Should generate a trigger function for every request in order
     * to wait an amount of time before showing the component. If the response
     * is received before the trigger was fired then the component should be displayed.
     * @param arg {show, id} an object containg the request id and a boolean value indicating if the loading should be
     * displayed
     */
    handleDisplayLoadingEvent(arg) {
        if (arg.show) {
            this.createTimerFunctionForRequest(arg.id);
        }
        else {
            this.closeLoadingComponent(arg.id);
        }
    }
    /**
     * Closes loading component
     * @param id the id of the request that wants to hide the loading component
     */
    closeLoadingComponent(id) {
        if (this.stillWaitingRequests[id]) {
            delete this.stillWaitingRequests[id];
        }
        else {
            this.deleteFromPendingResponseStructure(id);
        }
        this.verifyIfContinueLoading();
    }
    /**
     * Deletes from pending response structure
     * Removes a previous entry to the structure of pendingResponsesRequest
     * @param id The request id
     */
    deleteFromPendingResponseStructure(id) {
        if (this.pendingResponseRequests[id]) {
            clearTimeout(this.pendingResponseRequests[id].shift());
            if (this.pendingResponseRequests[id].length === 0) {
                delete this.pendingResponseRequests[id];
            }
        }
    }
    /**
     * Verifys if continue loading
     * Review the list of request that were triggered while the loading was on
     * if exists any the loading should be keep displayed on the screen
     */
    verifyIfContinueLoading() {
        if (Object.keys(this.stillWaitingRequests).length === 0) {
            this.hide = true;
        }
    }
    /**
     * Creates timer function for request
     * @param id the id of the request that generates the
     * trigger function for the loading component
     */
    createTimerFunctionForRequest(id) {
        if (this.pendingResponseRequests[id]) {
            this.pendingResponseRequests[id].push(this.createTimerForFunction(id));
        }
        else {
            this.pendingResponseRequests[id] = [this.createTimerForFunction(id)];
        }
    }
    /**
     * Creates timer for function
     * @param id the id of the request
     * @returns timer for function
     */
    createTimerForFunction(id) {
        return setTimeout(() => {
            return this.displayComponent(id, true);
        }, this.timing);
    }
    /**
     * Hides or Shows the loading component
     * @param show the value that indicates visible status
     */
    displayComponent(id, show) {
        if (!this.hide) {
            // the component is already displayed
            // then we need to store this as a stillWaitingRequest
            // and remove it from the pending response object
            this.stillWaitingRequests[id] = true;
            this.deleteFromPendingResponseStructure(id);
        }
        else {
            this.hide = !show;
        }
    }
    /**
     * OnDestroy lifecycle.
     *
     * @memberof LoadingComponent
     */
    ngOnDestroy() {
        this.events.forEach((evnt) => {
            this.service.core.getEvent().unSubscribe(evnt);
        });
    }
};
LoadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LoadingComponent, deps: [{ token: i1.WebMapService }, { token: LoadingStateService }], target: i0.ɵɵFactoryTarget.Component });
LoadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LoadingComponent, selector: "wm-loading", inputs: { timing: "timing", hide: "hide" }, ngImport: i0, template: "<div id=\"blockUI\" #blockUI [hidden]=\"hide\" class=\"modal-overlay\"></div>\r\n<div id=\"loading\" *ngIf=\"!isIEOrEdge\" [hidden]=\"hide\">\r\n    <svg class=\"spinner\" width=\"65px\" height=\"65px\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\">\r\n        <circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle>\r\n    </svg>\r\n</div>\r\n<div *ngIf=\"isIEOrEdge\" [hidden]=\"hide\" class=\"iespinner\">\r\n    <div class=\"lds-roller\">\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n    </div>\r\n</div>", styles: [".modal-overlay{width:100%;height:100%;position:absolute;overflow:hidden;top:0;left:0;background:rgba(0,0,0,.5)!important;z-index:100000000}.spinner{position:absolute;top:50%;left:50%;z-index:100000001;animation:rotator 1.4s linear infinite}@keyframes rotator{0%{transform:rotate(0)}to{transform:rotate(270deg)}}.path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;-webkit-animation-name:dash,colors;-webkit-animation-duration:1.4s,5.6s;-webkit-animation-timing-function:ease-in-out,ease-in-out;-webkit-animation-iteration-count:infinite,infinite;animation-name:dash,colors;animation-duration:1.4s,5.6s;animation-timing-function:ease-in-out,ease-in-out;animation-iteration-count:infinite,infinite}.loading{position:absolute;top:64%;left:45%;font-family:\"Impact, fantasy\";font-size:2em;animation:textcolors 5.6s ease-in-out infinite}@keyframes textcolors{0%{color:#4285f4}25%{color:#de3e35}50%{color:#f7c223}75%{color:#1b9a59}to{color:#4285f4}}@keyframes colors{0%{stroke:#4285f4}25%{stroke:#de3e35}50%{stroke:#f7c223}75%{stroke:#1b9a59}to{stroke:#4285f4}}@keyframes dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:46.75;transform:rotate(135deg)}to{stroke-dashoffset:187;transform:rotate(450deg)}}.lds-roller{display:inline-block;position:absolute;width:64px;height:64px;top:50%;left:50%;z-index:100000001}.lds-roller div{animation:lds-roller 1.2s cubic-bezier(.5,0,.5,1) infinite;transform-origin:32px 32px}.lds-roller div:after{content:\" \";display:block;position:absolute;width:6px;height:6px;border-radius:50%;background:#fff;margin:-3px 0 0 -3px}.lds-roller div:nth-child(1){animation-delay:-36ms}.lds-roller div:nth-child(1):after{top:50px;left:50px}.lds-roller div:nth-child(2){animation-delay:-72ms}.lds-roller div:nth-child(2):after{top:54px;left:45px}.lds-roller div:nth-child(3){animation-delay:-.108s}.lds-roller div:nth-child(3):after{top:57px;left:39px}.lds-roller div:nth-child(4){animation-delay:-.144s}.lds-roller div:nth-child(4):after{top:58px;left:32px}.lds-roller div:nth-child(5){animation-delay:-.18s}.lds-roller div:nth-child(5):after{top:57px;left:25px}.lds-roller div:nth-child(6){animation-delay:-.216s}.lds-roller div:nth-child(6):after{top:54px;left:19px}.lds-roller div:nth-child(7){animation-delay:-.252s}.lds-roller div:nth-child(7):after{top:50px;left:14px}.lds-roller div:nth-child(8){animation-delay:-.288s}.lds-roller div:nth-child(8):after{top:45px;left:10px}@keyframes lds-roller{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
LoadingComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.BaseComponents),
    __metadata("design:paramtypes", [WebMapService,
        LoadingStateService])
], LoadingComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-loading', template: "<div id=\"blockUI\" #blockUI [hidden]=\"hide\" class=\"modal-overlay\"></div>\r\n<div id=\"loading\" *ngIf=\"!isIEOrEdge\" [hidden]=\"hide\">\r\n    <svg class=\"spinner\" width=\"65px\" height=\"65px\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\">\r\n        <circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle>\r\n    </svg>\r\n</div>\r\n<div *ngIf=\"isIEOrEdge\" [hidden]=\"hide\" class=\"iespinner\">\r\n    <div class=\"lds-roller\">\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n    </div>\r\n</div>", styles: [".modal-overlay{width:100%;height:100%;position:absolute;overflow:hidden;top:0;left:0;background:rgba(0,0,0,.5)!important;z-index:100000000}.spinner{position:absolute;top:50%;left:50%;z-index:100000001;animation:rotator 1.4s linear infinite}@keyframes rotator{0%{transform:rotate(0)}to{transform:rotate(270deg)}}.path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;-webkit-animation-name:dash,colors;-webkit-animation-duration:1.4s,5.6s;-webkit-animation-timing-function:ease-in-out,ease-in-out;-webkit-animation-iteration-count:infinite,infinite;animation-name:dash,colors;animation-duration:1.4s,5.6s;animation-timing-function:ease-in-out,ease-in-out;animation-iteration-count:infinite,infinite}.loading{position:absolute;top:64%;left:45%;font-family:\"Impact, fantasy\";font-size:2em;animation:textcolors 5.6s ease-in-out infinite}@keyframes textcolors{0%{color:#4285f4}25%{color:#de3e35}50%{color:#f7c223}75%{color:#1b9a59}to{color:#4285f4}}@keyframes colors{0%{stroke:#4285f4}25%{stroke:#de3e35}50%{stroke:#f7c223}75%{stroke:#1b9a59}to{stroke:#4285f4}}@keyframes dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:46.75;transform:rotate(135deg)}to{stroke-dashoffset:187;transform:rotate(450deg)}}.lds-roller{display:inline-block;position:absolute;width:64px;height:64px;top:50%;left:50%;z-index:100000001}.lds-roller div{animation:lds-roller 1.2s cubic-bezier(.5,0,.5,1) infinite;transform-origin:32px 32px}.lds-roller div:after{content:\" \";display:block;position:absolute;width:6px;height:6px;border-radius:50%;background:#fff;margin:-3px 0 0 -3px}.lds-roller div:nth-child(1){animation-delay:-36ms}.lds-roller div:nth-child(1):after{top:50px;left:50px}.lds-roller div:nth-child(2){animation-delay:-72ms}.lds-roller div:nth-child(2):after{top:54px;left:45px}.lds-roller div:nth-child(3){animation-delay:-.108s}.lds-roller div:nth-child(3):after{top:57px;left:39px}.lds-roller div:nth-child(4){animation-delay:-.144s}.lds-roller div:nth-child(4):after{top:58px;left:32px}.lds-roller div:nth-child(5){animation-delay:-.18s}.lds-roller div:nth-child(5):after{top:57px;left:25px}.lds-roller div:nth-child(6){animation-delay:-.216s}.lds-roller div:nth-child(6):after{top:54px;left:19px}.lds-roller div:nth-child(7){animation-delay:-.252s}.lds-roller div:nth-child(7):after{top:50px;left:14px}.lds-roller div:nth-child(8){animation-delay:-.288s}.lds-roller div:nth-child(8):after{top:45px;left:10px}@keyframes lds-roller{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: LoadingStateService }]; }, propDecorators: { timing: [{
                type: Input
            }], hide: [{
                type: Input
            }] } });

let ContainerComponent = class ContainerComponent {
    /* c8 ignore start */
    constructor(differs, webmapService) {
        this.differs = differs;
        this.webmapService = webmapService;
        /* c8 ignore stop */
        this.RemoveControl = new EventEmitter();
        /**
         * Keeps a reference to the dynamically
         * opened components.
         */
        this.openedComponents = {};
    }
    get controls() {
        return this.controlsCollection;
    }
    set controls(value) {
        this.controlsCollection = value;
        /* c8 ignore else */
        if (!this.differences && this.differs && value) {
            this.differences = this.differs.find(this.controlsCollection).create();
        }
    }
    /**
     * This is part of Angular lifecycle hook.
     * Review the changes in the control's collection and perform the
     * instantiation of the new control's
     */
    ngDoCheck() {
        /* c8 ignore else */
        if (this.differences) {
            const changes = this.differences.diff(this.controlsCollection);
            /* c8 ignore else */
            if (changes) {
                this.applyChanges(changes);
            }
        }
    }
    /**
       * This method apply changes when any of the following actions in the model is triggered:
         forEachRemovedItem: Something has been removed.
         forEachAddedItem: Something has been added.
         forEachChangedItem: Something has been changed.
       * @param changes Value with any change in the model
       */
    applyChanges(changes) {
        changes.forEachRemovedItem((record) => this.updateContainer(record.key, record.currentValue));
        changes.forEachAddedItem((record) => this.updateContainer(record.key, record.currentValue));
        changes.forEachChangedItem((record) => this.updateContainer(record.key, record.currentValue));
    }
    /**
     * Creates a new component instance inside the formscontainer component
     * @param componentToLoad The new component to load
     * @param id The component uniqueId.
     */
    loadComponent(id, componentToLoad, model) {
        const componentRef = this.componentContainer.viewContainerRef.createComponent(componentToLoad);
        componentRef.instance.model = model;
        this.openedComponents[id] = componentRef;
        this.assignIdToWebmapSelector(componentRef, model);
        componentRef.instance.ref.detectChanges();
        componentRef.changeDetectorRef.detectChanges();
    }
    /**
     * Assign id property to the selectors of dynamic components
     * @param componentRef Component instance
     * @param model component model structure.
     */
    assignIdToWebmapSelector(componentRef, model) {
        if (componentRef.instance.el &&
            componentRef.instance.el.nativeElement &&
            model.Name) {
            componentRef.instance.el.nativeElement.id = model.Name;
            componentRef.instance.class = model.Name;
        }
    }
    /**
     * Adds a new component to the container Control
     * @param id The control's unique identifier
     */
    addControl(id) {
        this.webmapService.getModel(id).then((model) => {
            const webMapVersion = this.webmapService.config.webMapVersion;
            let componentType;
            if (model) {
                componentType =
                    webMapVersion === WMConstants.version4
                        ? TypeResolver.getType(model.Name)
                        : TypeResolver.getType(model.mapperId);
            } /* c8 ignore start*/
            else {
                WMLogger.instance().error(`Error in container. Component with id ${id} was missing`);
            }
            /* c8 ignore stop */
            /* c8 ignore next 3 */
            if (componentType) {
                this.loadComponent(id, componentType, model);
            }
        });
    }
    /**
     * Adds a new control to the specified container
     * @param key the control's unique id
     * @param value the control's component class
     */
    updateContainer(key, value) {
        if (value && !this.openedComponents[key]) {
            this.addControl(key);
        }
        else if (value === false) {
            this.removeControl(key);
        }
    }
    /**
     * Removes the dynamically opened control
     * @param id The control's id unique identifier.
     */
    removeControl(id) {
        if (this.openedComponents[id]) {
            this.openedComponents[id].destroy();
            delete this.openedComponents[id];
        }
        else {
            // Remove static control
            this.webmapService.getModel(id).then((model) => {
                /* c8 ignore else */
                if (model) {
                    const eventData = new EventData({ name: model.Name }, id);
                    this.RemoveControl.emit(eventData);
                }
            });
        }
    }
};
ContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerComponent, deps: [{ token: i0.KeyValueDiffers }, { token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.Component });
ContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ContainerComponent, selector: "wm-container", inputs: { controls: "controls" }, outputs: { RemoveControl: "RemoveControl" }, viewQueries: [{ propertyName: "componentContainer", first: true, predicate: ContainerDirective, descendants: true, static: true }], ngImport: i0, template: "<ng-container wm-content [hostComponent]=\"this\"></ng-container>", styles: [""], dependencies: [{ kind: "directive", type: ContainerDirective, selector: "[wm-content]", inputs: ["hostComponent"] }] });
ContainerComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.BaseComponents),
    __metadata("design:paramtypes", [KeyValueDiffers,
        WebMapService])
], ContainerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-container', template: "<ng-container wm-content [hostComponent]=\"this\"></ng-container>" }]
        }], ctorParameters: function () { return [{ type: i0.KeyValueDiffers }, { type: i1.WebMapService }]; }, propDecorators: { RemoveControl: [{
                type: Output
            }], controls: [{
                type: Input
            }], componentContainer: [{
                type: ViewChild,
                args: [ContainerDirective, { static: true }]
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Registrates the dataTransfer identity of the control.
 * @param ids Corresponds to the Control's type identifiers
 */
function dataTransfer(ids) {
    return function (target) {
        ids.forEach((key) => {
            TypeResolver.registrateType(key, target);
        });
        return target;
    };
}

let AlertComponent = class AlertComponent {
    constructor(webmapService, cdRef, toastr) {
        this.webmapService = webmapService;
        this.cdRef = cdRef;
        this.toastr = toastr;
        this.events = [];
        this.events.push(this.webmapService.core.getEvent().subscribe('alert', (alert) => {
            /* c8 ignore next */
            this.showAlert(alert.model);
        }));
    }
    ngOnInit() {
        this.toastr.overlayContainer = this.toastContainer;
    }
    /**
     * Executes on component destroy to unsubscribe the events
     */
    ngOnDestroy() {
        this.events.forEach((evnt) => {
            this.webmapService.core.getEvent().unSubscribe(evnt);
        });
    }
    /**
     * Shows alert component for [timeout] seconds
     * @param model the alert model
     */
    showAlert(model) {
        switch (model.type) {
            case 'success':
                this.toastr.success(model.message, model.caption, {
                    progressBar: true,
                    progressAnimation: 'decreasing',
                    timeOut: 10000
                });
                break;
            case 'error':
                this.toastr.error(model.message, model.caption, {
                    progressBar: true,
                    progressAnimation: 'decreasing',
                    timeOut: 10000
                });
                break;
            default:
                this.toastr.info(model.message, model.caption, {
                    progressBar: true,
                    progressAnimation: 'decreasing',
                    timeOut: 10000
                });
        }
    }
};
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i2.ToastrService }], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AlertComponent, selector: "wm-alert", viewQueries: [{ propertyName: "toastContainer", first: true, predicate: ToastContainerDirective, descendants: true, static: true }], ngImport: i0, template: "<div id=\"alert\" toastContainer>\r\n</div>", styles: [".notif{width:420px;height:150px;margin:40px auto;color:#fff;border-radius:4px;-ms-box-shadow:0 8px 12px #000000;-ms-box-shadow:0 8px 12px rgba(0,0,0,.3);box-shadow:0 8px 12px #000;box-shadow:0 8px 12px #0000004d;overflow:hidden;font-family:Signika Negative,Roboto,sans-serif;font-size:14px;position:absolute;bottom:0;right:35px;z-index:2147483647}.notif .success{background:#39cccc}.notif.error{background:#d35757}.notif .icon{padding:20px;font-size:56px}.notif .content,.notif .actions{height:100%;float:left}.notif .content{width:85%;display:flex;flex-direction:row;align-items:center}.notif .caption{margin-bottom:.2em;font-size:2em;color:#f5f5f5}.notif .message{color:#f5f5f5}.notif .actions{width:15%;display:flex;flex-direction:column;background:#000000;background:rgba(0,0,0,.4)}.notif .actions>*{flex-grow:1}.notif .action{position:relative;text-align:center;text-decoration:none}.notif .action:hover{background:#000000;background:rgba(0,0,0,.4)}.notif .action:after{content:attr(data-tooltip);display:none;position:absolute;right:110%;top:50%;margin-top:-1em;padding:.5em 1em;text-align:center;white-space:nowrap;background:#141414;border-radius:4px}.notif .action:hover:after{display:block}.notif a{color:inherit}\n"] });
AlertComponent = __decorate([
    dataTransfer(['alert']),
    __metadata("design:paramtypes", [WebMapService,
        ChangeDetectorRef,
        ToastrService])
], AlertComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-alert', template: "<div id=\"alert\" toastContainer>\r\n</div>", styles: [".notif{width:420px;height:150px;margin:40px auto;color:#fff;border-radius:4px;-ms-box-shadow:0 8px 12px #000000;-ms-box-shadow:0 8px 12px rgba(0,0,0,.3);box-shadow:0 8px 12px #000;box-shadow:0 8px 12px #0000004d;overflow:hidden;font-family:Signika Negative,Roboto,sans-serif;font-size:14px;position:absolute;bottom:0;right:35px;z-index:2147483647}.notif .success{background:#39cccc}.notif.error{background:#d35757}.notif .icon{padding:20px;font-size:56px}.notif .content,.notif .actions{height:100%;float:left}.notif .content{width:85%;display:flex;flex-direction:row;align-items:center}.notif .caption{margin-bottom:.2em;font-size:2em;color:#f5f5f5}.notif .message{color:#f5f5f5}.notif .actions{width:15%;display:flex;flex-direction:column;background:#000000;background:rgba(0,0,0,.4)}.notif .actions>*{flex-grow:1}.notif .action{position:relative;text-align:center;text-decoration:none}.notif .action:hover{background:#000000;background:rgba(0,0,0,.4)}.notif .action:after{content:attr(data-tooltip);display:none;position:absolute;right:110%;top:50%;margin-top:-1em;padding:.5em 1em;text-align:center;white-space:nowrap;background:#141414;border-radius:4px}.notif .action:hover:after{display:block}.notif a{color:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i2.ToastrService }]; }, propDecorators: { toastContainer: [{
                type: ViewChild,
                args: [ToastContainerDirective, { static: true }]
            }] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/* tslint:disable: no-invalid-this */
/**
 * Executes an event if the event is binded (in the server) in the current instance of the component.
 * For example:
 *
 * ```
 * // The extractor function is optional
 * @serverEvent('ServerClick', argsExtractor, targetExtractor)
 * click(event: any): void {
 * ...
 * }
 *
 * argsExtractor(event, component): any[] {
 *     // Do somehing with the event or the component
 *     return [{ someKey: extractedValue }];
 * }
 *
 * targetExtractor(event, component): object {
 *     // Find the custom event target
 *     return myEventTarget;
 * }
 * ```
 * @param eventName The name of the event in the server.
 * @param argsExtractor Optional function that receives the DOM event and the component instance, and returns an array
 * with the arguments to send to the server.
 * @param targetExtractor Optional function that receives the DOM event and the component instance, and returns the
 * selected event target.
 */
function serverEvent(eventName, argsExtractor, targetExtractor, callback, highPriority) {
    return function (target, propertyKey, descriptor) {
        const original = descriptor.value;
        descriptor.value = function (...args) {
            const excludedEvent = isExcludeEvents(eventName);
            // Trigger original method execution
            // if original method return true, the dynamic event triggering logic is canceled
            const cancelExecution = original.apply(this, args);
            let validationSuccess = true;
            //Validations performed in webforms
            if (this['baseValidatorService'] && this.webFormsIntercepted) {
                this.webFormsIntercepted = false;
                validationSuccess = this['baseValidatorService'].checkValidators(this['validationGroup']);
            }
            if (excludedEvent ||
                cancelExecution ||
                !validationSuccess ||
                serverEventsEnabled()) {
                return true;
            }
            // Verify event is binded in the server
            const component = this;
            // Verify server dynamic events are active
            // Verify that the execution was not cancelled by the original function
            // Verify that the component has the event binded
            if (IsDynamicBindEvent(component, eventName)) {
                // Detect UI Changes after user Event
                component.detectChanges();
                // Trigger event execution in the server
                const domEvent = args[0];
                const { receiver, serverArgs } = setEventParameters(argsExtractor, domEvent, component, targetExtractor);
                const command = new AngularCommand(receiver, propertyKey, '', eventName, receiver.id, serverArgs, highPriority);
                SendCommand(command, component, domEvent, callback);
            }
            return false;
        };
    };
}
function setEventParameters(argsExtractor, domEvent, component, targetExtractor) {
    const serverArgs = argsExtractor ? argsExtractor(domEvent, component) : null;
    const receiver = targetExtractor
        ? targetExtractor(domEvent, component)
        : component;
    return { receiver, serverArgs };
}
function IsDynamicBindEvent(component, eventName) {
    return (ApplicationIsUsingDynamicServerEvents() &&
        ComponentHasBindedEvent(component, eventName));
}
function SendCommand(command, component, domEvent, callback) {
    if (callback) {
        WebMapService.currentService.sendCommand(command, (Response) => {
            /* c8 ignore next */
            callback(component, domEvent);
        });
    }
    else {
        WebMapService.currentService.sendCommand(command);
    }
}
/**
 * Servers events enabled
 * Validates if the send to server feature is enabled
 * according to the flag in the angular client service
 * @returns true if events enabled
 */
function serverEventsEnabled() {
    return (WebMapService.currentService &&
        !WebMapService.currentService.enabledServerEvents);
}
function ApplicationIsUsingDynamicServerEvents() {
    return (WebMapService.currentService &&
        WebMapService.currentService.config &&
        WebMapService.currentService.config.useDynamicServerEvents);
}
function ComponentHasBindedEvent(component, eventName) {
    return component && component.isBindedEvent(eventName);
}
/* c8 ignore start */
function excludeEvents() {
    return [
        'dwnitemchange',
        'dwnrowchanging',
        'dwnrowchange',
        'dwnitemchangefocus'
    ];
}
/* c8 ignore stop */
function isExcludeEvents(eventName) {
    return (WebMapService.currentService &&
        WebMapService.currentService.config.useBundleEvent &&
        excludeEvents().indexOf(eventName) !== -1);
}

/***********************************************************************

Copyright (C) Mobilize.Net  info@mobilize.net - All Rights Reserved
This file is part of the Mobilize Frameworks, which is
proprietary and confidential.
NOTICE: All information contained herein is, and remains
the property of Mobilize.Net  Corporation.
The intellectual and technical concepts contained herein are
proprietary to Mobilize.Net  Corporation and may be covered
by U.S. Patents, and are protected by trade secret or copyright law.
Dissemination of this information or reproduction of this material
is strictly forbidden unless prior written permission is obtained
from Mobilize.Net  Corporation.
This file is subject to the terms and conditions defined in
file 'LICENSE.txt', which is part of this source code package.
***********************************************************************/
function UpdateState() {
    return function (target, key, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            const result = originalMethod.apply(this, args);
            WebMapService.currentService.core.publishEvent('detectChanges', {
                BE2FEUpdate: true
            });
            return result;
        };
        return descriptor;
    };
}

/***********************************************************************

Copyright (C) Mobilize.Net  info@mobilize.net - All Rights Reserved
This file is part of the Mobilize Frameworks, which is
proprietary and confidential.
NOTICE: All information contained herein is, and remains
the property of Mobilize.Net  Corporation.
The intellectual and technical concepts contained herein are
proprietary to Mobilize.Net  Corporation and may be covered
by U.S. Patents, and are protected by trade secret or copyright law.
Dissemination of this information or reproduction of this material
is strictly forbidden unless prior written permission is obtained
from Mobilize.Net  Corporation.
This file is subject to the terms and conditions defined in
file 'LICENSE.txt', which is part of this source code package.
***********************************************************************/
function CustomEvent() {
    return function (target, key, descriptor) {
        descriptor.value = function (...args) {
            // Pending customEvents spyke definition
            return null;
        };
        return descriptor;
    };
}

/* eslint-disable prettier/prettier */
/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Checks if the index is a number, if it's a number, if it's in range or
 * if it's different of NaN
 * @param {any} index - The index of the element to be removed.
 * @returns The return value is a boolean.
 */
function ValidateIndex(action) {
    return function (target, key, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            if (!isIndexValid(args[0]) ||
                (methodsNames.includes(key) && args[0] > this._internalArray.length) ||
                (!methodsNames.includes(key) && args[0] >= this._internalArray.length)) {
                throw new Error('Invalid index');
            }
            return originalMethod.apply(this, args);
        };
        return descriptor;
    };
}
// Method's names that allow to use the array's length as index
const methodsNames = ['insert', 'insertRange'];
/**
 * If the index is not a number, or if it is a number but less than zero, then
 * return false, otherwise return true.
 * @param index - The index of the item to be removed.
 * @returns A boolean value.
 */
function isIndexValid(index) {
    return !isNaN(index) && typeof index === 'number' && index >= 0;
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class BringTopService {
    constructor(rendererFactory) {
        this.notifyWindowAction = new Subject();
        this.render = rendererFactory.createRenderer(null, null);
    }
    /**
     * Gets event emitted notification
     */
    get notificationWindowAction() {
        return this.notifyWindowAction.asObservable();
    }
    /**
     * Notifies window bring to front
     * @param event event data
     */
    notifyWindowBringToFront(event) {
        this.notifyWindowAction.next(event);
    }
    /**
     * Bring element top
     * @param element the current html element
     */
    bringElementTop(element) {
        this.render.addClass(element.nativeElement, BringTopService.TOP_ELEMENT_CLASS);
        this.render.setStyle(element.nativeElement, 'z-index', BringTopService.TOP_ELEMENT_ZINDEX);
        this.render.setStyle(element.nativeElement, 'position', 'absolute');
        this.lastTopElement = element;
    }
    /**
     * Restores top element
     * @param element the element to restore
     */
    restoreTopElement(element) {
        this.render.removeClass(element.nativeElement, BringTopService.TOP_ELEMENT_CLASS);
        this.render.setStyle(element.nativeElement, 'z-index', 'auto');
    }
}
/**
 * Set the element as Top in current view
 */
BringTopService.TOP_ELEMENT_ZINDEX = 100;
/**
 * Top element class of bring top service
 */
BringTopService.TOP_ELEMENT_CLASS = 'WM-TOP';
BringTopService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BringTopService, deps: [{ token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
BringTopService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BringTopService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BringTopService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.RendererFactory2 }]; } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class FilterObject {
    /**
     * returns a new object with the properties != null from the parameter.
     * @param obj object used to get the assigned properties
     */
    static cleanCopy(obj) {
        const copy = {};
        for (const propName in obj) {
            if (obj.hasOwnProperty(propName) && obj[propName]) {
                copy[propName] = obj[propName];
            }
        }
        return copy;
    }
}

class MockService {
    constructor(service, items, resultPostCall, customFunction) {
        this.config = {
            useDynamicServerEvents: true,
            usePercentage: false,
            webMapVersion: 'v5'
        };
        this.forms = { formdialog: '86c8eebf-6e27-4ddb-8eca-6e68c096ca70' };
        this.result = '';
        this.enabledServerEvents = true;
        this.core = {
            getEvent() {
                return {
                    publish: (event, data) => { },
                    subscribe: (event, lambda) => 'token',
                    unSubscribe: (token) => false
                };
            }
        };
        this.currentService = this;
        /* c8 ignore next */
        this.serviceModel = service;
        this.itemstoFetch = items;
        this.postResult = resultPostCall;
        this.customFunction = customFunction;
    }
    /* c8 ignore start */
    sendCommand(command, callback) {
        this.result = 'Done';
    }
    /* c8 ignore stop */
    /* c8 ignore start */
    fetch(url, id) {
        return {
            subscribe: (callback) => {
                callback(this.customFunction ? this.customFunction(url) : this.itemstoFetch);
            }
        };
    }
    /* c8 ignore stop */
    /* c8 ignore start */
    post(url, data) {
        return {
            subscribe: (callback) => {
                callback(this.postResult);
            }
        };
    }
    /* c8 ignore stop */
    /* c8 ignore next 5 */
    getModel(Id) {
        return new Promise((resolve) => {
            return resolve(this.serviceModel);
        });
    }
    /* c8 ignore next 3 */
    invoke(arg) {
        this.result = 'Done';
    }
    /* c8 ignore next */
    notifyChange(mode, property) { }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
// @dynamic
class RemoveAmpersand {
    /**
     * Removes ampersand in value pass as parameter
     * @param value Text to remove ampersand
     * @param [underline] Determines if character aside ampersand
     * should be underline
     * @returns Text with ampersand removed.
     */
    static remove(value, underline) {
        const replace = underline ? '<u>$1</u>' : '$1';
        return value ? value.replace(/&(.|$)/g, replace) : value;
    }
}

class TestUtils {
    /**
     * Tests that the event emitter gets called when the source event of the given name is triggered,
     * @param fixture The fixture of the component,
     * @param emitter The event emitter of the component.
     * @param name The name of the source event of the original component.
     * @param selector The css selector to identify the component inside the fixture.
     * @param event The event object of the original component.
     */
    static testEventWasCalled(fixture, emitter, name, selector, event) {
        /* c8 ignore next 4 */
        jest.spyOn(emitter, 'emit').mockImplementation(() => { });
        TestUtils.triggerHtmlEvent(fixture, name, selector, event);
        fixture.detectChanges();
        expect(emitter.emit).toHaveBeenCalled();
    }
    /**
     * Triggers the specified HTML event in the component specified by the selector
     * @param fixture The fixture of the component,
     * @param name The name of the source event of the original component.
     * @param selector The css selector to identify the component inside the fixture.
     * @param event The event object of the original component.
     */
    /* c8 ignore start */
    static triggerHtmlEvent(fixture, name, selector, event) {
        const eventValue = event || { event: name };
        const component = fixture.debugElement.query(By.css(selector));
        component.triggerEventHandler(name, eventValue);
    }
    /* c8 ignore stop */
    /**
     * Returns a new mock instance of the WebMapService.
     * @param serviceModel The mock service that contains the available models.
     * @param itemsToFetch The items that should be returned when calling fetch().
     * @param postResult The expected result when calling post().
     */
    /* c8 ignore start */
    static getWebMapServiceStub(serviceModel, itemsToFetch, postResult, customServiceFunction) {
        return new MockService(serviceModel, itemsToFetch, postResult, customServiceFunction);
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class ValidateObject {
    static isEmptyObject(obj) {
        for (const property in obj) {
            /* c8 ignore else */
            if (obj.hasOwnProperty(property)) {
                return false;
            }
        }
        return true;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Enum to describe the target position of the version info
 */
var VersionInfoPosition;
(function (VersionInfoPosition) {
    VersionInfoPosition[VersionInfoPosition["topLeft"] = 0] = "topLeft";
    VersionInfoPosition[VersionInfoPosition["topRight"] = 1] = "topRight";
    VersionInfoPosition[VersionInfoPosition["bottomLeft"] = 2] = "bottomLeft";
    VersionInfoPosition[VersionInfoPosition["bottomRight"] = 3] = "bottomRight";
})(VersionInfoPosition || (VersionInfoPosition = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Helper to allow applications to report information about its current version.
 *
 * This class will provide functions to register version info (Dictionary<key, value>) and then it will
 * provide the user with the means to display that information, usually with a combination of keys to be
 * pressed
 *
 */
const defaultcssSelector = 'versionInfoContainer';
class AppVersionInfoHelper {
    /**
     * For cases using iframes usually multiple instances of this class get created (once per window), this
     * property will allow to access a single instance stored in window.top
     *
     * @readonly
     * @private
     * @static
     * @type {AppVersionInfoHelper}
     * @memberof AppVersionInfoHelper
     */
    static get singleton() {
        let res = window.top['appVersionInfoHelper'];
        if (res == null) {
            window.top['appVersionInfoHelper'] = this;
            res = this;
        }
        return res;
    }
    /**
     * Gets the info DOM object to present the version info to the user
     *
     * @private
     * @static
     * @type {*}
     * @memberof AppVersionInfoHelper
     */
    static get infoDOM() {
        return AppVersionInfoHelper.singleton._infoDOM;
    }
    /**
     * Sets the info DOM object to present the version info to the user
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set infoDOM(value) {
        if (AppVersionInfoHelper.singleton._infoDOM != null) {
            try {
                window.top.document.body.removeChild(AppVersionInfoHelper.singleton._infoDOM);
            }
            catch { }
        }
        AppVersionInfoHelper.singleton._infoDOM = value ?? null;
        AppVersionInfoHelper.infoVisible = false;
    }
    /**
     * Gets the CSSDOM to be used by the version info.
     * CSS rules are used so the user can override them in any application
     *
     * @readonly
     * @private
     * @static
     * @type {*}
     * @memberof AppVersionInfoHelper
     */
    static get infoCSSDOM() {
        return AppVersionInfoHelper.singleton._infoCSSDOM;
    }
    /**
     * Gets the CSSDOM to be used by the version info.
     * CSS rules are used so the user can override them in any application
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set infoCSSDOM(value) {
        if (AppVersionInfoHelper.singleton._infoCSSDOM != null) {
            try {
                window.top.document.head.removeChild(AppVersionInfoHelper.singleton._infoCSSDOM);
            }
            catch { }
        }
        AppVersionInfoHelper.singleton._infoCSSDOM = value ?? null;
    }
    /**
     * Gets the list of target listeners for the events to show the version info
     *
     * @private
     * @static
     * @type {HTMLElement[]}
     * @memberof AppVersionInfoHelper
     */
    static get targetListener() {
        return AppVersionInfoHelper.singleton._targetListener;
    }
    /**
     * Sets the list of target listeners for the events to show the version info
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set targetListener(value) {
        if (AppVersionInfoHelper.singleton._targetListener != null) {
            AppVersionInfoHelper.unregisterEventListeners();
        }
        AppVersionInfoHelper.singleton._targetListener = value ?? null;
    }
    /**
     * Gets the version info configured to be presented.
     *
     * @private
     * @static
     * @type {{[key: string]: string}}
     * @memberof AppVersionInfoHelper
     */
    static get versionInfo() {
        return AppVersionInfoHelper.singleton._versionInfo;
    }
    /**
     * Sets the version info configured to be presented.
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set versionInfo(value) {
        AppVersionInfoHelper.singleton._versionInfo = value;
    }
    /**
     * Gets the position to show the version info.
     *
     * @private
     * @static
     * @type {VersionInfoPosition}
     * @memberof AppVersionInfoHelper
     */
    static get position() {
        return AppVersionInfoHelper.singleton._position;
    }
    /**
     * Sets the position to show the version info.
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set position(value) {
        AppVersionInfoHelper.singleton._position =
            value ?? VersionInfoPosition.topRight;
    }
    /**
     * Gets the key sequence to use to check if the user wants to show the version info
     *
     * @private
     * @static
     * @type {IKeySequence}
     * @memberof AppVersionInfoHelper
     */
    static get keySequence() {
        return AppVersionInfoHelper.singleton._keySequence;
    }
    /**
     *  Sets the key sequence to use to check if the user wants to show the version info
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set keySequence(value) {
        AppVersionInfoHelper.singleton._keySequence = value;
    }
    /**
     * Gets the flag indicating if the version info is being displayed
     *
     * @private
     * @static
     * @type {boolean}
     * @memberof AppVersionInfoHelper
     */
    static get infoVisible() {
        return AppVersionInfoHelper.singleton._infoVisible;
    }
    /**
     * Sets the flag indicating if the version info is being displayed
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set infoVisible(value) {
        AppVersionInfoHelper.singleton._infoVisible = value ?? false;
    }
    /**
     * Gets the cssSelector to use for the container of the version info window. Default = versionInfoContainer
     *
     * @private
     * @static
     * @type {string}
     * @memberof AppVersionInfoHelper
     */
    static get cssSelector() {
        return AppVersionInfoHelper.singleton._cssSelector;
    }
    /**
     * Sets the cssSelector to use for the container of the version info window. Default = versionInfoContainer
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static set cssSelector(value) {
        AppVersionInfoHelper.singleton._cssSelector =
            value ?? defaultcssSelector;
    }
    /**
     * Register version info to show/hide to the user when pressing a certain key sequence. Options can be provided to customize or adapt
     * to the application, for instance options could be:
     *  {
     *      targetListener: DOM Tag object that can listen for keydown event and trigger the visualization of the version info.
     *      position: corner where the information will be shown, possible values are <topLeft, topRight, bottomLeft, bottomRight>
     *      keySequence: {
     *          control: true|false. Ctrl should be pressed
     *          shift: true|false. Shift should be pressed
     *          alt: true|false. Alt should be pressed
     *          key: letter that should be pressed
     *      }
     *      cssSelector: .class to be used in the info window, by default is .versionInfoContainer
     *  }
     *
     * This function should be called only once in the application and hopefully on the entry point screen.
     *
     * @static
     * @param {{[key: string]: string}} info version info to present
     * @param {HTMLElement} [targetListener=null] HTML Dom object where the helper will be listening the events to show the version info.
     * If none is provided by default will be window.top.document.body or window.top.document.documentElement.
     * @param {VersionInfoPosition} [position=VersionInfoPosition.topRight] position to show the version information, by default topRight.
     * @param {IKeySequence} [keySequence=null] sequence to listen or by default = alt+shift+w
     * @memberof AppVersionInfoHelper
     */
    static RegisterVersionInfo(info, options = null) {
        AppVersionInfoHelper.Clear();
        AppVersionInfoHelper.versionInfo = info ?? null;
        AppVersionInfoHelper.position =
            options?.position ?? VersionInfoPosition.topRight;
        AppVersionInfoHelper.keySequence = options?.keySequence ?? {
            alt: true,
            shift: true,
            key: 'w'
        };
        AppVersionInfoHelper.targetListener =
            options?.targetListener ??
                window.top?.document?.body ??
                window.top.document?.documentElement ??
                null;
        AppVersionInfoHelper.cssSelector =
            options?.cssSelector ?? defaultcssSelector;
        AppVersionInfoHelper.updateInfoDOM();
        if (AppVersionInfoHelper.infoDOM != null) {
            AppVersionInfoHelper.registerEventListeners();
        }
    }
    /**
     * Clears all previous information, listeners, etc.
     *
     * @static
     * @memberof AppVersionInfoHelper
     */
    static Clear() {
        AppVersionInfoHelper.infoDOM = null;
        AppVersionInfoHelper.infoCSSDOM = null;
        AppVersionInfoHelper.targetListener = null;
        AppVersionInfoHelper.versionInfo = null;
        AppVersionInfoHelper.position = VersionInfoPosition.topRight;
        AppVersionInfoHelper.keySequence = null;
        AppVersionInfoHelper.infoVisible = false;
        AppVersionInfoHelper.cssSelector = defaultcssSelector;
    }
    /**
     * Register the event listeners for all target listeners
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static registerEventListeners() {
        AppVersionInfoHelper.targetListener?.addEventListener?.('keydown', AppVersionInfoHelper.keyDownHandler);
    }
    /**
     * Unregister the event listeners of all target listeners
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static unregisterEventListeners() {
        AppVersionInfoHelper.targetListener?.removeEventListener?.('keydown', AppVersionInfoHelper.keyDownHandler);
    }
    /**
     * Global listener for keydown event, to handle when the user request to show the version info
     *
     * @private
     * @static
     * @param {KeyboardEvent} event
     * @memberof AppVersionInfoHelper
     */
    static keyDownHandler(event) {
        if ((!AppVersionInfoHelper.keySequence.control ||
            AppVersionInfoHelper.keySequence.control == event.ctrlKey) &&
            (!AppVersionInfoHelper.keySequence.shift ||
                AppVersionInfoHelper.keySequence.shift == event.shiftKey) &&
            (!AppVersionInfoHelper.keySequence.alt ||
                AppVersionInfoHelper.keySequence.alt == event.altKey) &&
            `${AppVersionInfoHelper.keySequence.key}`.toLowerCase() ==
                `${event.key}`.toLowerCase()) {
            if (!AppVersionInfoHelper.infoVisible) {
                AppVersionInfoHelper.checkCSSDOM();
                window.top.document.body.appendChild(AppVersionInfoHelper.infoDOM);
            }
            else {
                window.top.document.body.removeChild(AppVersionInfoHelper.infoDOM);
            }
            AppVersionInfoHelper.infoVisible = !AppVersionInfoHelper.infoVisible;
        }
    }
    /**
     * Ensures the default CSS rules for the version info will be added to the document. By default .css rules are used
     * so the user can override them if required
     *
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static checkCSSDOM() {
        if (AppVersionInfoHelper.infoCSSDOM == null) {
            AppVersionInfoHelper.infoCSSDOM =
                AppVersionInfoHelper.generateDefaultCSSDOM();
        }
    }
    /**
     * Generates a default css DOM object to be used for the version info.
     *
     * @private
     * @static
     * @return {*}  {HTMLStyleElement}
     * @memberof AppVersionInfoHelper
     */
    static generateDefaultCSSDOM() {
        const styles = [
            `.${AppVersionInfoHelper.cssSelector} {
                position: fixed;
                display: inline-grid;
                grid-template-columns: auto auto;
                column-gap: 4px;
                row-gap: 1px;
                z-index: 10000000;
                background-color: #ade6b3;
                padding: 5px;
                margin: 1px;
                border-radius: 4px;
                box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
                font-family: Verdana, Geneva, Tahoma, sans-serif;
                font-size: 11px;            
            }`,
            `.${AppVersionInfoHelper.cssSelector} > .keyCell {
                font-weight: bold;
            }`,
            `.${AppVersionInfoHelper.cssSelector}.topLeft {
                top: 0px;
                left: 0px;
            }`,
            `.${AppVersionInfoHelper.cssSelector}.topRight {
                top: 0px;
                right: 0px;
            }`,
            `.${AppVersionInfoHelper.cssSelector}.bottomLeft {
                bottom: 0px;
                left: 0px;
            }`,
            `.${AppVersionInfoHelper.cssSelector}.bottomRight {
                bottom: 0px;
                right: 0px;
            }`
        ];
        const styleEl = window.top.document.createElement('style');
        //Required so .sheet gets populated
        if (window.top.document.head.childElementCount > 0) {
            window.top.document.head.insertBefore(styleEl, window.top.document.head.children[0]);
        }
        else {
            window.top.document.head.appendChild(styleEl);
        }
        const styleSheet = styleEl.sheet;
        styles.forEach((rule) => {
            styleSheet.insertRule(rule, styleSheet.cssRules.length);
        });
        return styleEl;
    }
    /**
     * Using the information of versionInfo, it generates the DOM object that is going to be displayed, DOM will
     * be stored in infoDOM.
     *
     * The structure will be:
     * <div class='versionInfoContainer <topLeft|topRight|bottomLeft|bottomRight>'>
     *  <div class='keyCell'>Component Name</div>
     *  <div>Version</div>
     * <div>
     * @private
     * @static
     * @memberof AppVersionInfoHelper
     */
    static updateInfoDOM() {
        AppVersionInfoHelper.infoDOM = null;
        const keys = AppVersionInfoHelper.versionInfo != null
            ? Object.keys(AppVersionInfoHelper.versionInfo)
            : [];
        if (keys?.length > 0) {
            const infoDiv = window.top.document.createElement('div');
            infoDiv.className = AppVersionInfoHelper.cssSelector;
            switch (AppVersionInfoHelper.position) {
                case VersionInfoPosition.topLeft:
                    infoDiv.className += ' topLeft';
                    break;
                case VersionInfoPosition.bottomLeft:
                    infoDiv.className += ' bottomLeft';
                    break;
                case VersionInfoPosition.bottomRight:
                    infoDiv.className += ' bottomRight';
                    break;
                default:
                    infoDiv.className += ' topRight';
            }
            keys.forEach((key) => {
                const itemKey = window.top.document.createElement('div');
                itemKey.innerText = `${key}:`;
                itemKey.className = 'keyCell';
                infoDiv.appendChild(itemKey);
                const itemValue = window.top.document.createElement('div');
                itemValue.innerText = AppVersionInfoHelper.versionInfo[key];
                infoDiv.appendChild(itemValue);
            });
            AppVersionInfoHelper.infoDOM = infoDiv;
        }
    }
}
AppVersionInfoHelper._infoDOM = null;
AppVersionInfoHelper._infoCSSDOM = null;
AppVersionInfoHelper._targetListener = null;
AppVersionInfoHelper._versionInfo = null;
AppVersionInfoHelper._position = VersionInfoPosition.topRight;
AppVersionInfoHelper._keySequence = null;
AppVersionInfoHelper._cssSelector = defaultcssSelector;
AppVersionInfoHelper._infoVisible = false;

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class BaseComponentsModule {
}
BaseComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BaseComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: BaseComponentsModule, bootstrap: [FormsContainerComponent,
        LoadingComponent,
        ContainerComponent,
        AlertComponent], declarations: [FormsContainerComponent,
        ContainerDirective,
        LoadingComponent,
        ContainerComponent,
        AlertComponent], imports: [CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        WebMapModule,
        BrowserAnimationsModule // required animations module
    ], exports: [FormsContainerComponent,
        ContainerDirective,
        LoadingComponent,
        ContainerComponent,
        AlertComponent] });
BaseComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseComponentsModule, imports: [CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        WebMapModule,
        BrowserAnimationsModule // required animations module
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FormsContainerComponent,
                        ContainerDirective,
                        LoadingComponent,
                        ContainerComponent,
                        AlertComponent
                    ],
                    exports: [
                        FormsContainerComponent,
                        ContainerDirective,
                        LoadingComponent,
                        ContainerComponent,
                        AlertComponent
                    ],
                    bootstrap: [
                        FormsContainerComponent,
                        LoadingComponent,
                        ContainerComponent,
                        AlertComponent
                    ],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        BrowserModule,
                        WebMapModule,
                        BrowserAnimationsModule // required animations module
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * Convert an iterable to an array.
 * @param iterable - An iterable object to convert to an array.
 * @returns An array of the iterable's values.
 */
function iuToArray(iterable) {
    return [...iterable];
}
/**
 *   Metadata key for storing supported interfaces
 */
const supportedInterfacesCompatibilityMetadataKey = Symbol('wm_compatibility_supported_interfaces');

var List_1;
/**
 * List Class
 *
 * @export
 * @class List
 * @implements {IList}
 */
let List = List_1 = class List {
    static initializeSupportedInterfaces() {
        if (!List_1.interfacesInitialized) {
            const setMetadataInfo = Reflect.metadata(supportedInterfacesCompatibilityMetadataKey, [
                'System.Collections.Generic.ICollection`1',
                'System.Collections.Generic.IList`1',
                'System.Collections.Generic.IList',
                'System.Collections.IList'
            ]);
            setMetadataInfo(List_1);
            List_1.interfacesInitialized = true;
        }
    }
    constructor(arg) {
        this._internalArray = [];
        const newLocal = typeof arg;
        // capacity argument still not supported
        if (newLocal != 'undefined' && newLocal != 'number') {
            const initialValues = arg;
            this.internalArray = [...initialValues];
        }
        List_1.initializeSupportedInterfaces();
    }
    /**
     * Gets the internal array.
     *
     * @type {T[]}
     * @memberof List
     */
    get internalArray() {
        // eslint-disable-next-line no-underscore-dangle
        return this._internalArray;
    }
    /**
     * Sets the internal array.
     *
     * @type {T[]}
     * @memberof List
     */
    set internalArray(value) {
        // eslint-disable-next-line no-underscore-dangle
        this._internalArray = value;
    }
    /**
     * Gets  element by index.
     *
     * @type {T[]}
     * @memberof List
     */
    /* c8 ignore next 4 */
    getItem(index) {
        if (this.ContainsObservables) {
            const idModel = this.internalArray[index];
            return WebMapService.currentService.core.getModel(idModel);
        }
        return this.internalArray[index];
    }
    /**
     * Sets  element by index.
     *
     * @type {T[]}
     * @memberof List
     */
    /* c8 ignore next 5 */
    setItem(index, value) {
        this.internalArray[index] = value;
    }
    /**
     * Index of value in list
     *
     * @param {T} value
     * @returns
     * @memberof List
     * @wMethod IndexOf
     */
    indexOf(value) {
        return this.internalArray.indexOf(value);
    }
    /**
     * Inserts element in index
     *
     * @param {number} index
     * @param {T} value
     * @memberof List
     * @wMethod Insert
     */
    insert(index, value) {
        this.internalArray.splice(index, 0, value);
    }
    /**
     * Removes element at index
     *
     * @param {number} index
     * @memberof List
     * @wMethod RemoveAt
     */
    removeAt(index) {
        this.internalArray.splice(index, 1);
    }
    /**
     * Gets the count of elements in list
     *
     * @readonly
     * @type {number}
     * @memberof List
     * @wProperty Count
     */
    get count() {
        return this.internalArray.length;
    }
    /**
     * Adds an element to the list
     *
     * @param {T} value
     * @memberof List
     * @wMethod Add
     */
    add(value) {
        this.internalArray.push(value);
    }
    /**
     * Clears the list
     *
     * @memberof List
     * @wMethod Clear
     */
    clear() {
        this.internalArray.splice(0, this.internalArray.length);
    }
    /**
     * Check if a value is contained in the list
     *
     * @param {T} value
     * @returns {boolean}
     * @memberof List
     * @wMethod Contains
     */
    contains(value) {
        return this.internalArray.indexOf(value) !== -1;
    }
    /**
     * Removes a value from the list
     *
     * @param {T} value
     * @returns {boolean}
     * @memberof List
     * @wMethod Remove
     */
    remove(value) {
        const copyValue = this.ContainsObservables ? value['id'] : value;
        const idx = this.internalArray.indexOf(copyValue);
        if (idx !== -1) {
            this.internalArray.splice(idx, 1);
            return this.removeHandler(copyValue);
        }
        return false;
    }
    /**
     * This is an extension of remove method
     * In order to send Message with correct parameter.
     *
     * @param {*} idx
     * @return {*}  {boolean}
     * @memberof List
     */
    removeHandler(value) {
        return value !== undefined;
    }
    /**
     * Performs an action on each element of the list
     *
     * @param {(e: T) => void} action
     * @memberof List
     * @wMethod ForEach
     */
    forEach(action) {
        for (const obj of this.internalArray) {
            action(obj);
        }
    }
    /**
     * Adds elements of an iterable to the list
     *
     * @param {Iterable<T>} range
     * @memberof List
     * @wMethod AddRange
     */
    addRange(range) {
        for (const obj of range) {
            this._internalArray.push(obj);
        }
    }
    /**
     * Inserts elements of an iterable to the list in a position
     *
     * @param {number} position
     * @param {Iterable<T>} range
     * @memberof List
     * @wMethod InsertRange
     */
    insertRange(index, range) {
        this.internalArray.splice(index, 0, ...range);
    }
    sort(p) {
        if (typeof p === 'object') {
            this.internalArray.sort(p.Compare);
        }
        else if (typeof p === 'function') {
            this.internalArray.sort(p);
        }
        else {
            if (this.internalArray.length > 0 &&
                typeof this.internalArray[0] === 'object') {
                this.internalArray.sort((a, b) => {
                    if (a?.CompareTo && b?.CompareTo) {
                        return a.CompareTo(b);
                    }
                    else {
                        return 0;
                    }
                });
            }
            else {
                this.internalArray.sort();
            }
        }
    }
    /**
     * Copy the list to a target array
     *
     * @param {T[]} target
     * @param {number} index
     * @memberof List
     * @wMethod CopyTo
     */
    copyTo(target, index) {
        for (let i = index; i < target.length; i++) {
            target[i] = this.internalArray[i];
        }
    }
    /**
     * Removes all elements from the collection by a predicate
     *
     * @param {(e: T) => boolean} predicate
     * @returns
     * @memberof List
     * @wMethod RemoveAll
     */
    removeAll(predicate) {
        let removed = 0;
        for (let i = this.internalArray.length - 1; i >= 0; i--) {
            if (predicate(this.internalArray[i])) {
                this.internalArray.splice(i, 1);
                removed++;
            }
        }
        return removed;
    }
    /**
     * Converts the list to an array
     *
     * @returns
     * @memberof List
     * @wMethod ToArray
     */
    toArray() {
        return [...this.internalArray];
    }
    [Symbol.iterator]() {
        return this.internalArray[Symbol.iterator]();
    }
};
List.interfacesInitialized = false;
__decorate([
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Object)
], List.prototype, "getItem", null);
__decorate([
    SendMessage('this[]'),
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object]),
    __metadata("design:returntype", void 0)
], List.prototype, "setItem", null);
__decorate([
    SendMessage(),
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object]),
    __metadata("design:returntype", void 0)
], List.prototype, "insert", null);
__decorate([
    SendMessage(),
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], List.prototype, "removeAt", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], List.prototype, "add", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], List.prototype, "clear", null);
__decorate([
    SendMessage('remove'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Boolean)
], List.prototype, "removeHandler", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], List.prototype, "addRange", null);
__decorate([
    SendMessage(),
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object]),
    __metadata("design:returntype", void 0)
], List.prototype, "insertRange", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], List.prototype, "removeAll", null);
List = List_1 = __decorate([
    registerModel('lstwrppr'),
    __metadata("design:paramtypes", [Object])
], List);

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Base class for dictionary types.
 *
 * @export
 * @abstract
 * @class Dictionary
 * @implements {ISimpleDictionary<K, V>}
 * @template K
 * @template V
 * @wType System.Collections.Generic.Dictionary`2
 * @wNetSupport
 */
class Dictionary {
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Stores a Key-Value pair in an array-like object.
 *
 * @export
 * @class KeyValue
 * @extends {Array}
 * @template K
 * @template V
 * @wType System.Collections.Generic.KeyValuePair`2
 * @wIgnoreDeclaration
 * @wNetSupport
 */
class KeyValue extends Array {
    /**
     * Creates an instance of `KeyValue`.
     *
     * @param {K} [key]
     * @param {V} [value]
     * @memberof KeyValue
     */
    constructor(key, value) {
        super();
        this[0] = key;
        this[1] = value;
    }
    /**
     * Gets the key of this `KeyValue` pair.
     *
     * @readonly
     * @type {K}
     * @memberof KeyValue
     * @wIgnore
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    get Key() {
        return this[0];
    }
    /**
     * Gets the value of this `KeyValue` pair.
     *
     * @readonly
     * @type {V}
     * @memberof KeyValue
     * @wIgnore
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    get Value() {
        return this[1];
    }
    /**
     * Returns a new instance of `KeyValue`, ready to be used as a regular array.
     *
     * @static
     * @template TKey
     * @template TValue
     * @param {TKey} [key]
     * @param {TValue} [value]
     * @return {*}  {[TKey, TValue]}
     * @memberof KeyValue
     */
    static pair(key, value) {
        return new KeyValue(key, value);
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
var SimpleDictionary_1;
let SimpleDictionary = SimpleDictionary_1 = class SimpleDictionary extends Dictionary {
    constructor() {
        super();
        this._internalMap = new Map();
    }
    /**
     * Set internalMap
     *
     * @memberof SimpleDictionary
     */
    set internalMap(obj) {
        const keysArray = obj[0];
        const valueArray = obj[1];
        this._internalMap = new Map();
        for (let i = 0; i < keysArray.length; i++) {
            this._internalMap.set(keysArray[i], valueArray[i]);
        }
    }
    /**
     * get InternalMap
     *
     * @type {Map<K, V>}
     * @memberof SimpleDictionary
     */
    get internalMap() {
        return this._internalMap;
    }
    /**
     * Get item by key.
     * @param {K} key
     * @memberof SimpleDictionary
     * @wMethod getItem
     */
    getItem(key) {
        if (this.internalMap.has(key)) {
            return this.internalMap.get(key);
        }
        else {
            return null;
        }
    }
    /**
     * Set item by key.
     * @param {V} value
     * @param {K} value
     * @memberof SimpleDictionary
     * @wMethod setItem
     */
    /* c8 ignore next 4 */
    setItem(key, value) {
        this.internalMap.set(key, value);
    }
    /**
     * Get keys
     * @memberof SimpleDictionary
     * @wMethod keys
     */
    get keys() {
        return new List(this.internalMap.keys()).internalArray;
    }
    /**
     * Get values.
     * @memberof SimpleDictionary
     * @wMethod values
     */
    get values() {
        return new List(this.internalMap.values()).internalArray;
    }
    /**
     * Add value and key.
     * @param {V} value
     * @param {K} key
     * @memberof SimpleDictionary
     * @wMethod add
     */
    add(key, value) {
        this.internalMap.set(key, value);
    }
    /**
     * Returns true or false if the key exists.
     * @param {K} key
     * @memberof SimpleDictionary
     * @wMethod hasKey
     */
    hasKey(key) {
        return this.internalMap.has(key);
    }
    /**
     * Removes a entry to the dictionary
     *
     * @param {K} key
     * @memberof SimpleDictionary
     * @wMethod Remove
     */
    remove(key) {
        this.internalMap.delete(key);
    }
    /**
     * Tries to get a value by key in the dictionary
     *
     * @param {K} key
     * @param {V} value
     * @memberof SimpleDictionary
     * @wMethod TryGetValue
     * @wIgnore
     */
    tryGetValue(key, value) {
        if (this.internalMap.has(key)) {
            value(this.internalMap.get(key));
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Gets the count of elements in the dictionary
     *
     * @abstract
     * @type {number}
     * @memberof SimpleDictionary
     * @wProperty Count
     */
    get count() {
        return this.internalMap.size;
    }
    /**
     * Add a value to the dictionary
     *
     * @abstract
     * @param {[K, V]} value
     * @memberof SimpleDictionary
     * @wMethod Add
     */
    addEntry(value) {
        this.internalMap.set(value[0], value[1]);
    }
    /**
     * Clear the dictionary
     *
     * @abstract
     * @memberof SimpleDictionary
     * @wMethod Clear
     */
    clear() {
        this.internalMap.clear();
    }
    /**
     * Return true or false if the value exists in the dictionary
     * @param {[K, V]} value
     * @memberof SimpleDictionary
     * @wMethod Contains
     */
    /* c8 ignore next 3 */
    contains(value) {
        // TODO implementation pending
        return false;
    }
    /**
     * Return true or false if the key exists in the dictionary
     * @param {K} key
     * @memberof SimpleDictionary
     * @wMethod ContainsKey
     */
    containsKey(key) {
        return this.internalMap.has(key);
    }
    /**
     * Return true or false if the value exists in the dictionary
     * @param {V} value
     * @memberof SimpleDictionary
     * @wMethod ContainsValue
     */
    containsValue(value) {
        const res = this.values?.find((v) => value === v);
        return res ? true : false;
    }
    /**
     * Copy the dictionary to a target array
     *
     * @param {[K, V][]} target
     * @param {number} index
     * @memberof SimpleDictionary
     * @wMethod CopyTo
     */
    copyTo(target, index) { }
    [Symbol.iterator]() {
        return this.internalArray[Symbol.iterator]();
    }
    /**
     * Gets the internal array.
     *
     * @type {[K, V][]}
     * @memberof SimpleDictionary
     */
    get internalArray() {
        return [...this.internalMap].map((x) => KeyValue.pair(x[0], x[1]));
    }
    /**
     * Creates a new SimpleDictionary object with the elements that matched the given predicate
     * @param predicate a function that filters this SimpleDictionary elements.
     * @returns a new SimpleDictionary with filtered in elements.
     */
    filter(predicate) {
        const result = new SimpleDictionary_1();
        this.internalArray.forEach((element) => {
            if (predicate(element)) {
                result.addEntry(element);
            }
        });
        return result;
    }
};
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SimpleDictionary.prototype, "setItem", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SimpleDictionary.prototype, "add", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SimpleDictionary.prototype, "remove", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SimpleDictionary.prototype, "addEntry", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SimpleDictionary.prototype, "clear", null);
SimpleDictionary = SimpleDictionary_1 = __decorate([
    registerModel('dctwrppr'),
    __metadata("design:paramtypes", [])
], SimpleDictionary);

class ArrayHelper {
    /**
     * It takes an array and a predicate function and returns true if the predicate
     * function returns true for any element in the array
     * @param array - SimpleArray<U>
     * @param predicate - (e: any) => boolean
     * @returns A boolean
     */
    static exists(array, predicate) {
        for (let i = array.length - 1; i >= 0; i--) {
            if (predicate(array.getItem(i))) {
                return true;
            }
        }
        return false;
    }
    /**
     * It copies the first `length` elements from `sourceArray` to `destinationArray`
     * @param sourceArray - The array to copy from
     * @param destinationArray - SimpleArray<U>
     * @param {number} length - number
     * @returns A string.
     */
    static copy(sourceArray, destinationArray, length) {
        if (length > sourceArray.length) {
            return 'Source array was not long enough';
        }
        if (length > destinationArray.length) {
            return 'Destination array was not long enough';
        }
        for (let index = 0; index < length; index++) {
            const val = sourceArray.getItem(index);
            destinationArray.setItem(index, val);
        }
    }
}

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
var SimpleArray_1;
let SimpleArray = SimpleArray_1 = class SimpleArray {
    static initializeSupportedInterfaces() {
        if (!SimpleArray_1.interfacesInitialized) {
            const setMetadataInfo = Reflect.metadata(supportedInterfacesCompatibilityMetadataKey, [
                'System.Collections.Generic.ICollection`1',
                'System.Collections.Generic.IList`1',
                'System.Collections.Generic.IList',
                'System.Collections.IList'
            ]);
            setMetadataInfo(SimpleArray_1);
            SimpleArray_1.interfacesInitialized = true;
        }
    }
    /* c8 ignore start */
    constructor(length, arg) {
        this._internalArray = [];
        this._length = length;
        if (arg) {
            this._internalArray = [...arg];
        }
        else {
            for (let index = 0; index < this._length; index++) {
                this._internalArray.push(null);
            }
        }
        SimpleArray_1.initializeSupportedInterfaces();
    }
    /* c8 ignore stop */
    /* c8 ignore next 3 */
    [Symbol.iterator]() {
        return this._internalArray[Symbol.iterator]();
    }
    /**
     * Return the count of elements in array
     * @memberof SimpleArray
     */
    get count() {
        return this._length;
    }
    /**
     * Return the length of array
     * @memberof SimpleArray
     */
    get length() {
        return this._length;
    }
    /**
     * Copy the list to a target array
     *
     * @param {T[]} target
     * @param {number} index
     * @memberof SimpleArray
     * @wMethod CopyTo
     */
    copyTo(target, index) {
        for (let i = index; i < target.length; i++) {
            target[i] = this._internalArray[i];
        }
    }
    /**
     * Return item by index
     *
     * @param {number} index
     * @memberof SimpleArray
     * @wMethod GetItem
     */
    /* c8 ignore next 4 */
    getItem(index) {
        if (this.ContainsObservables) {
            const idModel = this._internalArray[index];
            return WebMapService.currentService.core.getModel(idModel);
        }
        return this._internalArray[index];
    }
    /**
     * Set item by index
     * @param {T} value
     * @param {number} index
     * @memberof SimpleArray
     * @wMethod SetItem
     */
    /* c8 ignore next 5 */
    setItem(index, value) {
        this._internalArray[index] = value;
    }
};
SimpleArray.interfacesInitialized = false;
__decorate([
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Object)
], SimpleArray.prototype, "getItem", null);
__decorate([
    SendMessage('this[]'),
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object]),
    __metadata("design:returntype", void 0)
], SimpleArray.prototype, "setItem", null);
SimpleArray = SimpleArray_1 = __decorate([
    registerModel('arrwrppr'),
    __metadata("design:paramtypes", [Number, Object])
], SimpleArray);

/**
 * ArrayList class
 *
 * @export
 * @class ArrayList
 * @implements {IList}
 * @implements {Iterable<unknown>}
 */
let ArrayList = class ArrayList {
    constructor() {
        /**
         * _internalArray
         *
         * @protected
         * @type {unknown[]}
         * @memberof ArrayList
         */
        this._internalArray = [];
    }
    /**
     * Support iterator for arrayList
    *
    * @return {*}  {Iterator<unknown>}
    * @memberof ArrayList
    */
    /* c8 ignore next 5 */
    *[Symbol.iterator]() {
        for (const key of this.internalArray) {
            yield key.Value;
        }
    }
    /**
     * Gets the number of elements actually contained in the ArrayList.
     *
     * @readonly
     * @type {number}
     * @memberof ArrayList
     */
    get count() {
        return this.internalArray.length;
    }
    /**
     * Removes the element at the specified index of the ArrayList.
     *
     * @param {number} index
     * @memberof ArrayList
     */
    removeAt(index) {
        this.internalArray.splice(index, 1);
    }
    /**
     * Remove element from array.
     *
     * @param {*} value
     * @return {*}  {boolean}
     * @memberof ArrayList
     */
    remove(value) {
        let valueToDelete;
        const idx = this.internalArray.findIndex((element) => {
            if (element.ContainsObservable) {
                const model = WebMapService.currentService.core.getModel(element.Value);
                if (model.id === value.Value) {
                    valueToDelete = WebMapService.currentService.core.getModel(element.Value);
                    return true;
                }
                return false;
            }
            else {
                valueToDelete = value;
                return element.Value === value;
            }
        });
        if (idx !== -1) {
            const removeResult = this.internalArray.splice(idx, 1).length > 0;
            return this.removeHandler(removeResult ? valueToDelete : undefined);
        }
        return false;
    }
    /**
     * Function in charge of validate value and apply decorator
     *
     * @param {*} value
     * @return {*}  {boolean}
     * @memberof ArrayList
     */
    removeHandler(value) {
        return value !== undefined;
    }
    /**
     * Adds an object to the end of the ArrayList.
     *
     * @param {unknown} value
     * @memberof ArrayList
     */
    add(value) {
        this.internalArray.push({ ContainsObservable: false, Value: value });
    }
    /**
     * Sorts the elements in the entire ArrayList.
     *
     * @memberof ArrayList
     */
    sort() {
        if (this.internalArray.length > 0 &&
            typeof this.internalArray[0].Value === 'object') {
            this.internalArray.sort((a, b) => {
                if (a.Value?.CompareTo && b.Value?.CompareTo) {
                    return a.Value.CompareTo(b.Value);
                }
            });
        }
        else {
            this.internalArray.sort((a1, b2) => {
                const nestedTernaryResult = (a1.Value < b2.Value) ? -1 : 0;
                return (a1.Value > b2.Value) ? 1 : nestedTernaryResult;
            });
        }
    }
    /**
     * Removes all elements from the ArrayList.
     *
     * @memberof ArrayList
     */
    clear() {
        this.internalArray.splice(0, this.internalArray.length);
    }
    /**
     * internalArray
     *
     * @readonly
     * @type {unknown[]}
     * @memberof ArrayList
     */
    get internalArray() {
        // eslint-disable-next-line no-underscore-dangle
        return this._internalArray;
    }
    /**
     * internalArray
    *
    * @memberof ArrayList
    */
    /* c8 ignore next 3 */
    set internalArray(value) {
        this._internalArray = value;
    }
    /**
   * Gets  element by index.
   *
   * @type {T[]}
   * @memberof List
   */
    /* c8 ignore next 4 */
    getItem(index) {
        const itemObject = this.internalArray[index];
        if (itemObject && itemObject.ContainsObservable) {
            const idModel = this.internalArray[index];
            return WebMapService.currentService.core.getModel(idModel.Value);
        }
        return this.internalArray[index].Value;
    }
};
__decorate([
    SendMessage(),
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ArrayList.prototype, "removeAt", null);
__decorate([
    SendMessage('remove'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Boolean)
], ArrayList.prototype, "removeHandler", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ArrayList.prototype, "add", null);
__decorate([
    SendMessage(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ArrayList.prototype, "clear", null);
__decorate([
    ValidateIndex(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Object)
], ArrayList.prototype, "getItem", null);
ArrayList = __decorate([
    registerModel('arrlstwrppr')
], ArrayList);

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Subscription Event helper for custom Events
 *
 * @export
 * @class SubscriptionEvent
 * @template T
 */
class SubscriptionEvent {
    constructor() {
        /**
         * T Function to be customized and context to be called.
         *
         * @type {[T, any][]}
         * @memberof SubscriptionEvent
         */
        this.handlers = [];
    }
    /**
     * Dispatch and fire event
     *
     * @param {...any[]} args
     * @return {*}  {T}
     * @memberof SubscriptionEvent
     */
    dispatch(...args) {
        return this.fire(args);
    }
    /**
     * Fires the event and executes each handler
     *
     * @param {any[]} args
     * @memberof SubscriptionEvent
     */
    fire(args) {
        //Map will create a copy to be immune of changes in this.handlers like calls to removeHandler, if no copy of the collection is created
        //changes in this.handlers tend to skip items in the loop
        for (const handler of this.handlers.map((x) => {
            return x;
        })) {
            //The handler to be invoked might be removed by code, so we have to double check
            const idx = this.handlers.findIndex((h) => h == handler);
            if (idx >= 0 && handler[0] instanceof Function) {
                handler[0].apply(handler[1] ?? window, args);
            }
        }
    }
    /**
     * Add handler to the event
     *
     * @param {T} handler
     * @param {*} [self=null]
     * @returns {T}
     * @memberof SubscriptionEvent
     */
    addHandler(handler, self = null) {
        this.handlers.push([handler, self]);
        return handler;
    }
    /**
     * Removes handler from the event
     *
     * @param {T} handler
     * @param {*} [self=null]
     * @memberof SubscriptionEvent
     */
    removeHandler(handler, self = null) {
        if (handler) {
            let idx = this.handlers.findIndex((h) => {
                debugger;
                return h[0] == handler && h[1] == self;
            });
            // Final search for lambda expression using toString()
            idx =
                idx > 0
                    ? idx
                    : this.handlers.findIndex((h) => h[0].toString() == handler.toString() && h[1] == self);
            if (idx >= 0) {
                this.handlers.splice(idx, 1);
            }
        }
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AppVersionInfoHelper, ArrayHelper, ArrayList, BaseComponentsModule, BringTopService, ContainerComponent, ContainerDirective, CustomEvent, EventData, FilterObject, FormsContainerComponent, List, LoadingComponent, LoadingStateService, MockService, RemoveAmpersand, SimpleArray, SimpleDictionary, SubscriptionEvent, TestUtils, TypeResolver, UpdateState, ValidateIndex, ValidateObject, dataTransfer, serverEvent };
